import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@talentech/components";
import axios from "axios";
import {
  FormData,
  GetFormByResponseParams,
  FormSubmissionPayload,
} from "../../types/feedback.types";
import { API_CONSTANTS } from "../../constants/form.constants";

// Ensure all axios requests include the anti-forgery header
axios.defaults.headers.common["X-CSRF"] = "1";
const baseUrl = process.env.API_URL as string;

export const feedbackApi = createApi({
  reducerPath: "feedbackApi",
  baseQuery: axiosBaseQuery({ baseUrl: "" }),
  endpoints: (builder) => ({
    getFormById: builder.query<FormData, { formId: string } | string>({
      query: (arg) => {
        const formId = typeof arg === "string" ? arg : arg.formId;
        return {
          url: `${baseUrl}/v1/Forms/${formId}`,
          method: "GET",
          withCredentials: true,
          headers: {
            Accept: `application/json; charset=${API_CONSTANTS.DEFAULT_CHARSET}`,
          },
        };
      },
    }),

    getFormByResponse: builder.query<FormData, GetFormByResponseParams>({
      query: (params) => ({
        url: `${baseUrl}/v1/Forms/FormResponse`,
        method: "GET",
        withCredentials: false,
        params,
        headers: {
          Accept: `application/json; charset=${API_CONSTANTS.DEFAULT_CHARSET}`,
        },
      }),
    }),

    updateFormResponse: builder.mutation<void, FormSubmissionPayload>({
      query: (body) => ({
        url: `${baseUrl}/v1/Forms/FormResponse`,
        method: "PUT",
        withCredentials: false,
        headers: {
          Accept: `application/json; charset=${API_CONSTANTS.DEFAULT_CHARSET}`,
          "Content-Type": `application/json; charset=${API_CONSTANTS.DEFAULT_CHARSET}`,
        },
        data: body,
      }),
    }),
  }),
});

export const {
  useGetFormByIdQuery,
  useGetFormByResponseQuery,
  useUpdateFormResponseMutation,
} = feedbackApi;
